module.exports = __webpack_public_path__ + "static/media/po-reman-3.68c66670.png";